import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService, ConfigServerService, CustomHttp } from '../../../../../core';
import { NegocioFilter } from '../../filter';
import { NegocioSearchView } from '../../negocio-search-view';
import { NegocioOportunidadeSearch } from '../negocio-oportunidade-search';

@Injectable({
    providedIn: 'root'
})
export class NegocioOportunidadeSearchHttpService {
    private pathApi: string;

    constructor(private authService: AuthService,
                configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/negociooportunidade`;
    }

    /** Realiza a pesquisa do Search View das oportunidades de negócios */
    searchView(idFunilVenda: number, filter: NegocioFilter, orderByColumn: number, orderByDir: string): Observable<NegocioSearchView> {
        let params = new HttpParams();

        // Funil de Venda
        if (idFunilVenda) {
            params = params.append('idFunilVenda', idFunilVenda.toString());
        }

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Order By
        params = params.append('orderBy', orderByColumn ? orderByColumn.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);

        return this.customHttp.get<NegocioSearchView>(`${this.pathApi}/0/view`, {params});
    }

    /** Realiza a pesquisa das oportunidades de negócios */
    search(idsQualificacoes: number[], orderByColumn: number, orderByDir: string): Observable<NegocioOportunidadeSearch[]> {
        let params = new HttpParams();

        // IDs oportunidades
        if (idsQualificacoes && idsQualificacoes.length > 0) {
            idsQualificacoes.forEach(idOportunidade => params = params.append('idOportunidade', idOportunidade.toString()));
        } else {
            params = params.append('idOportunidade', '0'); // Para não trazer nada
        }

        // Order By
        params = params.append('orderBy', orderByColumn ? orderByColumn.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);

        return this.customHttp.get<NegocioOportunidadeSearch[]>(this.pathApi, {params});
    }

    /** Pesquisa uma única oportunidade de negócio através do ID informado */
    searchOne(idOportunidade: number): Observable<NegocioOportunidadeSearch> {
        return this.customHttp.get<NegocioOportunidadeSearch>(`${this.pathApi}/${idOportunidade}/search`);
    }
}
